module.exports = __webpack_public_path__ + "img/06tab-ecasino.73e4d245.png";